<template>
    <div v-if="currentOrder">
        <div>
            <div class="form-check- mt-4" :style="'padding: 4px 4px 4px 24px; border-radius:12px;'">
                <div class="d-flex align-items-center bnd-resp">
                    <div class="ms-2 w-100">
                        <span class="fw-medium fs-sm ppv2-text-black f-poppin">{{
                            $t('checkout.payment_klarna.three_times')
                        }}</span>
                    </div>

                    <span style="margin-left: 10px; color: red" v-if="errorPrelever">{{ errorPrelever }}</span>
                    <div
                        v-if="currentOrder.total_price - currentOrder.current_price < 35"
                        class="d-flex justify-center clientCards col-8 pe-0 flex-wrap gap-2"
                    >
                        <span class="fs-sm fw-normal" style="margin: auto; margin-left: 6px"
                            >{{ parseFloat((currentOrder.total_price - currentOrder.current_price) / 3).toFixed(2) }}
                            {{ $symbolCurrency }}</span
                        >

                        <v-btn
                            type="button"
                            style="
                                background: rgb(98, 194, 246) !important;
                                margin-right: 10px;
                                color: white;
                                border-radius: 12px;
                            "
                            @click="preleverKlarna"
                            :disabled="true"
                            :loading="loadingPreleve"
                            color="#2F4858"
                        >
                            0
                        </v-btn>
                    </div>
                    <div v-else class="d-flex justify-center clientCards col-8 pe-0 flex-wrap">
                        <span
                            class="fsm fw-normal"
                            style="margin: auto; margin-left: 6px; font-size: clamp(12px, 0.729545vw, 16px)"
                            >{{ parseFloat((currentOrder.total_price - currentOrder.current_price) / 3).toFixed(2) }}
                            {{ $symbolCurrency }}</span
                        >

                        <v-btn
                            type="button"
                            style="
                                background-color: #021832 !important;
                                color: white;
                                border-radius: 8px;
                                text-transform: none;
                                height: 40px;
                                width: 190px;
                                font-size: 12px;
                            "
                            @click="preleverKlarna"
                            :disabled="false"
                            :loading="loadingPreleve"
                            color="#2F4858"
                        >
                            {{ $t('checkout.payment_klarna.pay_three_times') }}
                            <svg
                                style="margin-left: 10px"
                                width="40"
                                height="41"
                                viewBox="0 0 40 41"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M35.3046 12.375H4.69536C2.10218 12.375 0 14.4772 0 17.0704V23.8594C0 26.4526 2.10218 28.5548 4.69536 28.5548H35.3046C37.8978 28.5548 40 26.4526 40 23.8594V17.0704C40 14.4772 37.8978 12.375 35.3046 12.375Z"
                                    fill="#FFB3C7"
                                />
                                <path
                                    d="M32.0309 19.4643C31.6586 19.2106 31.2241 19.0632 30.7742 19.0381C30.3244 19.0129 29.8761 19.1109 29.4778 19.3214C29.0795 19.532 28.7461 19.8473 28.5136 20.2332C28.2811 20.6192 28.1582 21.0612 28.1582 21.5118C28.1582 21.9624 28.2811 22.4044 28.5136 22.7903C28.7461 23.1763 29.0795 23.4915 29.4778 23.7021C29.8761 23.9127 30.3244 24.0107 30.7742 23.9855C31.2241 23.9603 31.6586 23.813 32.0309 23.5592V23.8592H33.4367V19.164H32.0309V19.4643ZM30.7524 22.7198C30.5162 22.7073 30.2889 22.6258 30.0985 22.4854C29.9082 22.3449 29.7632 22.1518 29.6814 21.9299C29.5997 21.7079 29.5848 21.4669 29.6386 21.2366C29.6925 21.0062 29.8126 20.7967 29.9842 20.634C30.1559 20.4713 30.3715 20.3624 30.6043 20.3209C30.8372 20.2794 31.0771 20.307 31.2944 20.4004C31.5117 20.4939 31.6968 20.6489 31.8269 20.8464C31.957 21.044 32.0263 21.2753 32.0263 21.5118C32.0173 21.8409 31.8781 22.1529 31.6393 22.3794C31.4004 22.6059 31.0814 22.7283 30.7524 22.7198Z"
                                    fill="black"
                                />
                                <path d="M12.7524 17.0715H11.2812V23.8593H12.7524V17.0715Z" fill="black" />
                                <path
                                    d="M25.6616 19.0376C25.3852 19.0213 25.109 19.0724 24.8567 19.1866C24.6045 19.3007 24.3838 19.4745 24.2136 19.693V19.1642H22.8136V23.8593H24.2304V21.3918C24.2196 21.2501 24.2393 21.1077 24.2884 20.9743C24.3375 20.8408 24.4147 20.7195 24.5148 20.6186C24.6149 20.5177 24.7356 20.4395 24.8686 20.3894C25.0017 20.3393 25.1439 20.3184 25.2858 20.3282C25.9036 20.3282 26.2588 20.6973 26.2588 21.3821V23.8593H27.663V20.8734C27.663 19.7807 26.7942 19.0376 25.6616 19.0376Z"
                                    fill="black"
                                />
                                <path
                                    d="M17.2001 19.4643C16.8278 19.2106 16.3933 19.0632 15.9434 19.0381C15.4935 19.0129 15.0453 19.1109 14.647 19.3214C14.2487 19.532 13.9153 19.8473 13.6828 20.2332C13.4503 20.6192 13.3274 21.0612 13.3274 21.5118C13.3274 21.9624 13.4503 22.4044 13.6828 22.7903C13.9153 23.1763 14.2487 23.4915 14.647 23.7021C15.0453 23.9127 15.4935 24.0107 15.9434 23.9855C16.3933 23.9603 16.8278 23.813 17.2001 23.5592V23.8592H18.6059V19.164H17.2001V19.4643ZM15.9215 22.7198C15.6853 22.7073 15.458 22.6258 15.2676 22.4854C15.0773 22.345 14.9322 22.1519 14.8505 21.93C14.7687 21.708 14.7538 21.467 14.8076 21.2366C14.8614 21.0063 14.9816 20.7968 15.1532 20.634C15.3248 20.4713 15.5404 20.3624 15.7732 20.3209C16.0061 20.2794 16.246 20.307 16.4633 20.4004C16.6806 20.4938 16.8658 20.6489 16.9959 20.8464C17.126 21.044 17.1953 21.2753 17.1953 21.5118C17.1863 21.8409 17.0472 22.1529 16.8083 22.3794C16.5695 22.6059 16.2505 22.7283 15.9215 22.7198H15.9215Z"
                                    fill="black"
                                />
                                <path
                                    d="M20.7804 19.7757V19.1642H19.3411V23.8595H20.7835V21.6675C20.7835 20.9278 21.5851 20.5303 22.1414 20.5303C22.147 20.5303 22.1525 20.5309 22.1581 20.5309V19.1644C21.8975 19.1575 21.6385 19.2087 21.4002 19.3144C21.1618 19.4202 20.9501 19.5778 20.7804 19.7757Z"
                                    fill="black"
                                />
                                <path
                                    d="M34.9292 22.1941C34.7547 22.1941 34.5841 22.2459 34.439 22.3428C34.2939 22.4398 34.1808 22.5776 34.114 22.7388C34.0473 22.9 34.0298 23.0775 34.0638 23.2486C34.0979 23.4198 34.1819 23.577 34.3053 23.7004C34.4287 23.8238 34.5859 23.9078 34.7571 23.9419C34.9283 23.9759 35.1057 23.9584 35.2669 23.8916C35.4281 23.8249 35.5659 23.7118 35.6629 23.5667C35.7598 23.4216 35.8116 23.251 35.8116 23.0765C35.8116 22.9606 35.7888 22.8458 35.7444 22.7388C35.7001 22.6317 35.6351 22.5344 35.5532 22.4525C35.4712 22.3706 35.3739 22.3056 35.2669 22.2612C35.1598 22.2169 35.0451 22.1941 34.9292 22.1941Z"
                                    fill="black"
                                />
                                <path
                                    d="M10.2669 17.0703H8.74225C8.74461 17.6818 8.60315 18.2852 8.3293 18.8319C8.05545 19.3786 7.65688 19.8532 7.16577 20.2174L6.56177 20.6698L8.90229 23.8615H10.8265L8.67305 20.9247C9.18092 20.4199 9.58337 19.8192 9.857 19.1575C10.1306 18.4958 10.27 17.7864 10.2669 17.0703Z"
                                    fill="black"
                                />
                                <path d="M6.37542 17.0703H4.84802V23.8612H6.37542V17.0703Z" fill="black" />
                            </svg>
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.clientCards .v-input__slot {
    border-radius: 24px;
}
</style>
<script>
import axios from 'axios'
export default {
    props: ['userId', 'orderId', 'currentOrder'],
    data: () => {
        return {
            menu: false,
            cartNum: null,
            expire: null,
            cvv: null,
            loadingAddCart: false,
            clientCards: [],
            selectCard: null,
            loadingPreleve: false,
            errorPrelever: null,
            amount: 0,
        }
    },
    methods: {
        async preleverKlarna() {
            this.errorPrelever = null
            this.loadingPreleve = true
            axios
                .post(
                    `/back-office/caisse/payByklarna`,
                    {
                        userId: this.userId,
                        orderId: this.orderId,
                        amount: this.currentOrder.total_price - this.currentOrder.current_price,
                    },
                    { withCredentials: true }
                )
                .then((res) => {
                    window.location.href = res.data.url
                })
                .catch((error) => {
                    this.errorPrelever = error?.response?.data?.message || this.$t('checkout.payment_klarna.error')
                })
                .finally(() => {
                    this.loadingPreleve = false
                })
        },
    },
}
</script>
